import React from 'react';
import styled from 'styled-components';
import { ThemeInterface } from '../../theme/ThemeInterface';

const Wrapper = styled.div`
  color: ${(props: ThemeInterface) => props.theme.colors.textDefault};
  margin-bottom: 10px;
  padding-right: 5px;

  > label {
    & > input {
      transform: scale(1.5);
      -ms-transform: scale(1.5);
      -webkit-transform: scale(1.5);
    }

    & > span {
      margin-left: 7px;
    }
  }
`;

const Checkbox: React.FC<any> = ({ label, ...rest }) => {
  return (
    <Wrapper>
      <label>
        <input type="checkbox" {...rest} />
        <span>{label}</span>
      </label>
    </Wrapper>
  );
};

export default Checkbox;
